<script setup lang="ts">
import { nextTick, ref, watch } from 'vue';
import { useRoute } from 'vue-router';

import { useDispatchDashboardViewStore } from '@/stores/useDispatchDashboardViewStore';
import { dispatchJobsTabs } from '@/constants/tabs';

import tabsStyles from '@/styles/tabs.module.scss';

const route = useRoute();
const dispatchDashboardViewStore = useDispatchDashboardViewStore();

// HACK wrong tab is selected first time, it seems that this behavior only appears when `:to` props are set
const tab = ref('');
watch(
  () => dispatchDashboardViewStore.query.tab,
  (newValue, oldValue) => {
    void nextTick(() => {
      tab.value = dispatchDashboardViewStore.query.tab;
    });
  },
  { immediate: true },
);
</script>

<template>
  <div :class="[$style.smartDispatchJobsTabs, tabsStyles.tabsWrapper]">
    <v-tabs :model-value="tab" :class="tabsStyles.tabs" :show-arrows="false">
      <v-tab
        :to="{ query: { ...route.query, tab: 'unallocated' } }"
        value="unallocated"
        :ripple="false"
        :class="tabsStyles.tab"
        variant="plain"
      >
        {{ dispatchJobsTabs.unallocated }}
      </v-tab>
      <v-tab
        :to="{ query: { ...route.query, tab: 'preallocated' } }"
        value="preallocated"
        :ripple="false"
        :class="tabsStyles.tab"
        variant="plain"
      >
        {{ dispatchJobsTabs.preallocated }}
      </v-tab>
      <v-tab
        :to="{ query: { ...route.query, tab: 'allocated' } }"
        value="allocated"
        :ripple="false"
        :class="tabsStyles.tab"
        variant="plain"
      >
        {{ dispatchJobsTabs.allocated }}
      </v-tab>
    </v-tabs>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';

.smartDispatchJobsTabs {
}
</style>
